<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-illustration">
        <img :src="require('@/images/dlbox.svg')" alt="Login Illustration" class="illustration-img">
      </div>
      <div class="login-form-wrapper">
        <h2 class="login-title">用户登录</h2>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <input 
              type="text" 
              v-model="username" 
              placeholder="请输入账号" 
              class="form-control"
              required
              @blur="onAccountBlur"
            />
          </div>
          <div class="form-group">
            <input 
              type="password" 
              v-model="password" 
              placeholder="请输入密码" 
              class="form-control"
              required
            />
          </div>
          <div class="form-group">
            <select v-model="accountSet" class="form-control">
              <option value="">请选择账套</option>
              <option v-for="t in tenants" :key="t.tenantID || t.TenantID" :value="t.tenantID || t.TenantID">
                {{ t.corpName || t.CorpName }}
              </option>
            </select>
          </div>
          <div v-if="errorMsg" class="login-error">{{ errorMsg }}</div>
          <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
            {{ loading ? '登录中...' : '登录' }}
          </button>
        </form>
      </div>
    </div>
    <div class="login-footer">
      <p>CopyRight© By 信息化管理平台</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login as sessionLogin } from '../utils/sessionManager'
import { getTenants, login as loginApi } from '../api/auth'

const router = useRouter()
const username = ref('')
const password = ref('')
const accountSet = ref('')
const tenants = ref([])
const loading = ref(false)
const errorMsg = ref('')

// 输入账号后，加载该账号对应的账套列表
const onAccountBlur = async () => {
  if (!username.value) {
    tenants.value = []
    accountSet.value = ''
    return
  }
  try {
    const res = await getTenants(username.value)
    if (res && res.resultType !== false) {
      tenants.value = res.data || res.Data || []
      if (tenants.value.length > 0) {
        accountSet.value = tenants.value[0].tenantID || tenants.value[0].TenantID || ''
      }
    }
  } catch (e) {
    console.error('加载账套列表失败', e)
  }
}

const handleLogin = async () => {
  errorMsg.value = ''
  if (!username.value || !password.value) {
    errorMsg.value = '请输入账号和密码'
    return
  }
  if (!accountSet.value) {
    errorMsg.value = '请选择账套'
    return
  }

  loading.value = true
  try {
    const res = await loginApi({
      tenantId: accountSet.value,
      account: username.value,
      password: password.value
    })

    const ok = res && (res.resultType === true || res.ResultType === true)
    if (!ok) {
      errorMsg.value = (res && (res.message || res.Message)) || '登录失败'
      return
    }

    sessionLogin({
      token: res.token || res.Token,
      user: {
        name: res.displayName || res.DisplayName || username.value,
        account: res.account || res.Account || username.value,
        tenantName: res.tenantName || res.TenantName || ''
      },
      accountSet: res.tenantId || res.TenantId || accountSet.value
    })
    router.push('/dashboard')
  } catch (e) {
    errorMsg.value = (e.response && e.response.data && (e.response.data.message || e.response.data.Message)) || '登录请求失败，请检查网络或服务'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #E8F5F3 0%, #D4EDDA 100%);
  padding: 20px;
  position: relative;
}

.login-container {
  width: 85%;
  max-width: 1100px;
  display: flex;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.login-illustration {
  width: 70%;
  height: 500px;
  background-color: #F8FAFC;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.illustration-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.login-form-wrapper {
  width: 30%;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
}

.login-title {
  text-align: center;
  color: #333;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 35px;
}

.form-group {
  margin-bottom: 20px;
}

.form-control {
  width: 100%;
  padding: 14px 18px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 15px;
  background-color: #F8FAFC;
  color: #333;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  appearance: none;
  cursor: pointer;
}

.form-control:focus {
  outline: none;
  border-color: #1ab394;
  box-shadow: 0 0 0 2px rgba(26, 179, 148, 0.2);
}

.form-control::placeholder {
  color: #94A3B8;
}

.btn {
  padding: 14px 24px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 15px;
}

.btn-primary {
  background-color: #1ab394;
  color: white;
}

.btn-primary:hover {
  background-color: #18a689;
}

.btn-block {
  width: 100%;
}

.login-error {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 8px;
  text-align: center;
}

.login-footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
}

.login-footer p {
  color: #64748B;
  font-size: 13px;
}

@media (max-width: 768px) {
  .login-container {
    width: 95%;
    flex-direction: column;
  }
  
  .login-illustration {
    width: 100%;
    height: 300px;
    padding: 25px;
  }
  
  .login-form-wrapper {
    width: 100%;
    padding: 40px;
  }
}
</style>
